
export const channelName = {
    text: "Are you sure you want to delete this channel?",
    content: "This action cannot be undone.",
    confirm: "Confirm Delete",
    cancel: "Cancel",
    confirmtext:"channel deleted successfully"
  };

export const stopSupport = {
    text: "Are you sure you want to close the live support?",
    content: "This action cannot be undone.",
    confirm: "Confirm stop",
    cancel: "Cancel",
    confirmtext:"the support has been stopped successfully"
  };

  export const BotName = {
    text: "Are you sure you want to delete this Bot?",
    content: "This action cannot be undone.",
    confirm: "Confirm Delete",
    cancel: "Cancel",
    confirmtext:"Bot deleted successfully"
  };

    export const user_details = {
    text: "Are you sure you want to delete this user?",
    content: "This action cannot be undone.",
    confirm: "Confirm Delete",
    cancel: "Cancel",
    confirmtext:"user deleted successfully"
  };